import React, {useState} from "react"
import {AsyncResultModal} from "../AsyncResultModal/AsyncResultModal"
import classNames from "classnames"
import {Result} from "neverthrow"
import {ErrorDocument, OkDocument} from "../../resources/common"
import {Assignment} from "../../resources/assignments"
import {AsyncResultIdleRequestState} from "../../types/asyncResultIdle"
import Admonition from "../Admonitions/Admonition"
import {refreshAndClose} from "../../utilities/modals"

interface AssignmentEscalateModalProps {
	title: string
	state: AsyncResultIdleRequestState<OkDocument<Assignment>, ErrorDocument>
	onSubmit: (...args: any[]) => Promise<Result<OkDocument<Assignment>, ErrorDocument>>
	primaryButtonText: string
	primaryButtonClassname: string
	withReasonText?: boolean
	isOptionalReasonText?: boolean
	reasonTextPlaceholder?: string
	closeModal: () => void
	onSuccess: () => void
	successText: string
	successClassname?: string
}

export type AssignmentStatusUpdateReasonsMapping = {
	[key: string]: {
		reason: string
		displayName: string
	}
}

export function AssignmentEscalateModal({
	state,
	onSubmit,
	primaryButtonText,
	primaryButtonClassname,
	withReasonText,
	reasonTextPlaceholder,
	closeModal,
	onSuccess,
	successText,
	successClassname,
}: AssignmentEscalateModalProps) {
	const [reasonText, setReasonText] = useState<string>("")
	const hasModalBody = withReasonText
	const modalOnSubmit = async () => {
		const onSubmitArgs: {reasonText: string} = {reasonText}
		return await onSubmit(onSubmitArgs)
	}

	return (
		<AsyncResultModal
			state={state}
			close={closeModal}
			buttonText={primaryButtonText}
			buttonClassname={primaryButtonClassname}
			successText={successText}
			successClassname={successClassname}
			onSubmit={modalOnSubmit}
			onSuccess={() => {
				setTimeout(refreshAndClose(onSuccess, closeModal), 1500)
			}}
			disableCloseOnSuccess
			errorToText={(err) => err.errors?.[0].title ?? "An error has occurred"}
		>
			<div className="assignment-escalate-modal-header">
				<h3 className={classNames("modal-title", "has-description")}>Are you sure you want to escalate?</h3>
				<span className="modal-description">Please explain the reason for escalating this assignment</span>
			</div>
			{hasModalBody && (
				<>
					<br />
					<div className="field">
						{withReasonText && (
							<div className="control assignment-status-update-reason-text">
								<textarea
									className="textarea"
									placeholder={reasonTextPlaceholder}
									value={reasonText}
									onChange={(e) => setReasonText(e.target.value)}
									maxLength={255}
									required
								/>
							</div>
						)}
					</div>

					<Admonition
						type="is-warning"
						title=""
						message="Once escalated, this assignment will be locked to you. It will be redirected to be evaluated by another team."
					/>
				</>
			)}
		</AsyncResultModal>
	)
}
